var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'properties')?_c('div',[_c('section-header-v1-properties',{attrs:{"formId":_vm.formId}})],1):_c('fb-text-v1',{ref:"textComponent",attrs:{"showType":_vm.showType,"properties":_vm.properties,"id":_vm.id,"form":_vm.form,"page":_vm.page,"componentsIdSuffix":_vm.componentsIdSuffix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }